const enUS = {
  "首页": "Home",
  "质量看板": "Quality Dashboard",
  "质量管理模块": "Quality Management Modules",
  "质量之声": "Quality Voice",
  "更多": "More",
  "全部": "All",
  "全球": "Global",
  "战略客户DPPM": "Strategic Customer DPPM",
  "客户评价": "Customer Score",
  "客户投诉次数 (Case)": "Customer Complaints (Case)",
  "客户审核通过率 (%)": "Customer Audit Pass Rate (%)",
  "送样失败次数/小批失败次数(Case)": "Sample/Small Batch Failures (Case)",
  "QA外观DPPM": "QA Appearance DPPM",
  "QA功能DPPM": "QA Function DPPM",
  "来料批次合格率(LAR) (%)": "Incoming Batch Pass Rate (LAR) (%)",
  "质量成本损失率(%)": "Quality Cost Loss Rate (%)",
  "DPPM": "DPPM",
  "目标": "Target",
  "评分": "Score",
  "投诉次数": "Complaints",
  "通过率": "Pass Rate",
  "失败次数": "Failures",
  "合格率": "Qualified Rate",
  "损失率": "Loss Rate",
  "模块开发中...": "Module is under development...",
  "加载中": "Loading",
  "暂无数据": "No Data",
  "待处理": "Pending",
  "已处理": "Processed",
  "暂无待处理": "No pending items",
  "暂无已处理": "No processed items",
  "获取消息列表": "Get Message List",
  "跳转页面": "Navigate to Page",
  "该消息暂无跳转链接": "No redirect link for this message",
  "页面不存在或无访问权限": "Page not found or no permission",
  "个人中心": "Profile",
  "退出登录": "Log Out",
  "登录/注册": "Login / Register",
  "工厂切换": "Plant Switch",
  "提示": "Notice",
  "我已知晓": "Got It",
  "确定要退出系统吗？": "Are you sure you want to log out?",
  "确定": "Confirm",
  "取消": "Cancel",
  "取 消": "Cancel",
  "确 定": "Confirm",
  "客户质量": "Customer Quality",
  "新产品开发质量": "New Product Quality",
  "生产过程质量": "Process Quality",
  "供方质量": "Supplier Quality",
  "质量体系": "Quality System",
  "知识经验库": "Knowledge Base",
  "实验室管理": "Laboratory Management",
  "检验设备管理": "Inspection Equipment",
  "统计分析": "Statistical Analysis",
  "客户定制": "Customer Customization",
  "客户投诉管理": "Customer Complaint Management",
  "客户满意度管理": "Customer Satisfaction Management",
  "客户质量需求管理": "Customer Quality Requirements",
  "NPI质量管理": "NPI Quality Management",
  "首末件": "First/Last Piece",
  "Q追溯": "Q Traceability",
  "停线管理": "Line Stop Management",
  "供应商档案管理": "Supplier Archive",
  "供应商导入": "Supplier Onboarding",
  "二供开发": "Second Source Development",
  "供应商退出": "Supplier Exit",
  "供应商绩效评估": "Supplier Performance Evaluation",
  "供应商审核": "Supplier Audit",
  "质量工作计划": "Quality Work Plan",
  "质量目标": "Quality Target",
  "内部审核管理": "Internal Audit Management",
  "外部审核管理": "External Audit Management",
  "专项质量活动管理": "Special Quality Activity Management",
  "质量成本管理": "Quality Cost Management",
  "质量奖惩": "Quality Reward & Penalty",
  "质量人员管理": "Quality Staff Management",
  "管理评审": "Management Review",
  "持续改进管理": "Continuous Improvement",
  "持续改进项目管理": "CI Project Management",
  "金点子": "Golden Ideas",
  "检验工具": "Inspection Tools",
  "统计工具": "Statistical Tools",
  "智新科技QMS": "Zhixin QMS",
  "凯德": "Kaide",
  "相关链接": "Related Links",
  "支持": "Support",
  "后台管理系统": "Admin System",
  "帮助中心": "Help Center",
  "意见反馈": "Feedback",
  "关于": "About",
  "关于我们": "About Us",
  "关注和而泰": "Follow H&T",
  "微信公众号": "WeChat Official Account",
  "客退管理": "Customer Return Management",
  "顾客满意度管理": "Customer Satisfaction Management",
  "设计质量管理": "Design Quality Management",
  "来料检验管理": "Incoming Inspection Management",
  "供方质量管理": "Supplier Quality Management",
  "元器件FA分析追踪管理": "Component FA Tracking",
  "供应商年度审核报告": "Supplier Annual Audit Report",
  "供应商专项/跟踪审核报告": "Supplier Special/Follow-up Audit Report",
  "质量目标管理": "Quality Target Management",
  "发布时间": "Publish Time",
  "发布人": "Publisher",
  "事业部": "BU",
  "客户名称": "Customer Name",
  "客户工厂": "Customer Factory",
  "和而泰工厂": "H&T Factory",
  "评价指标": "Evaluation KPI",
  "目标值": "Target Value",
  "，您好！": ", hello!",
  "工号": "Employee ID",
  "邮箱": "Email",
  "修改密码": "Change Password",
  "快捷入口": "Quick Access",
  "待处理事项": "To-do Items",
  "条": "items",
  "逾期未处理": "Overdue",
  "申请时间": "Apply Time",
  "去处理": "Handle",
  "预警提示": "Alerts",
  "公告通知": "Notifications",
  "查看": "View",
  "选择快捷入口": "Select Quick Access",
  "请选择": "Please Select",
  "请输入内容": "Please enter content",
  "请输入原始密码": "Please enter current password",
  "请输入新密码": "Please enter new password",
  "请输入重复密码": "Please re-enter password",
  "查看信息": "View Details",
  "删除成功": "Deleted successfully",
  "添加成功": "Added successfully",
  "密码修改成功": "Password updated successfully",
  "请确定密码": "Please confirm password",
  "请输入密码": "Please enter password",
  "请输入快捷入口名称": "Please enter shortcut name",
  "请选择角色": "Please select role",
  "两次密码输入不正确": "The two passwords do not match",
  "token令牌失效": "Token expired",
  "内部服务器错误": "Internal server error",
  "获取数据失败": "Failed to get data",
  "操作": "Operation",
  "月": "Month",
  "质量方针": "Quality Policy",
  "质量原则": "Quality Principles",
  "以人为本,技术领先,快速反应,以好的质量和交付赢得客户的信赖": "People-oriented, technology-leading, fast response, winning trust with quality and delivery",
  "不要未经客户批准私自变更 不要隐瞒质量问题</br>不要违反标准作业 不要拒绝质量改善</br>不要为质量问题找借口 不要篡改质量数据</br>不要跳工序作业 不要让评审未通过的项目量产</br>不要引入未通过审核的供应商 不要使用未经充分验证的物料": "Do not change without customer approval; do not hide quality issues; do not violate standards; do not refuse improvement; do not excuse quality issues; do not tamper data; do not skip process steps; do not mass-produce unapproved projects; do not onboard unapproved suppliers; do not use unverified materials",
  "深圳工厂": "Shenzhen Plant",
  "重庆工厂": "Chongqing Plant",
  "苏州工厂": "Suzhou Plant",
  "客户投诉闭环效率提升专项": "Customer Complaint Closure Efficiency Program",
  "新品导入阶段质量风险预警机制": "NPI Phase Quality Risk Early Warning",
  "制程不良率周度复盘机制上线": "Weekly Process Defect Review Launched",
  "供应商来料一致性改善案例发布": "Supplier Incoming Consistency Improvement Case",
  "体系审核问题项闭环通报（第一期）": "System Audit Closure Bulletin (Issue 1)",
  "客户表扬案例月度分享": "Monthly Customer Praise Sharing",
  "质量管理部": "Quality Management Dept.",
  "演示用户": "Demo User"
};

const zhCN = Object.keys(enUS).reduce((acc, key) => {
  acc[key] = key;
  return acc;
}, {});

export const LOCAL_I18N_MESSAGES = {
  zh: zhCN,
  en: enUS
};
